import * as types from '../mutations-types'

const state = {
  sosAlertActive: false,
  sosAlertQueue: [], // Array de alertas SOS activas
  currentAlertIndex: 0, // Índice de la alerta actualmente visible
  sosAlertData: null, // Mantener para compatibilidad
  sosAlertTimestamp: null, // Mantener para compatibilidad
  newAlertTrigger: 0 // Contador para disparar sonido en nuevas alertas
}

const getters = {
  isSosAlertActive: state => state.sosAlertActive,
  sosAlertData: state => state.sosAlertData,
  sosAlertTimestamp: state => state.sosAlertTimestamp,
  // Nuevos getters para la cola
  sosAlertQueue: state => state.sosAlertQueue,
  currentAlertIndex: state => state.currentAlertIndex,
  totalAlertsCount: state => state.sosAlertQueue.length,
  currentAlertNumber: state => state.currentAlertIndex + 1,
  hasMultipleAlerts: state => state.sosAlertQueue.length > 1,
  hasPreviousAlert: state => state.currentAlertIndex > 0,
  hasNextAlert: state => state.currentAlertIndex < state.sosAlertQueue.length - 1,
  newAlertTrigger: state => state.newAlertTrigger
}

const actions = {
  activateSosAlert({ commit, state }, data) {
    // Agregar timestamp si no existe
    const alertData = {
      ...data,
      timestamp: data.timestamp || new Date().toISOString(),
      id: data.sos_id || `sos_${Date.now()}_${Math.random().toString(36).substr(2, 9)}` // ID único para cada alerta
    }

    // Agregar la nueva alerta a la cola
    commit(types.ADD_SOS_ALERT_TO_QUEUE, alertData)

    // Disparar trigger para reproducir sonido (siempre que llega una nueva alerta)
    commit(types.TRIGGER_NEW_ALERT_SOUND)

    // Si no hay alertas activas, activar el sistema
    if (!state.sosAlertActive) {
      commit(types.SET_SOS_ALERT_ACTIVE, true)
      commit(types.SET_CURRENT_ALERT_INDEX, 0)
    }

    // Siempre actualizar la alerta actual visible (para compatibilidad)
    // Esto asegura que sosAlertData siempre esté sincronizado con la alerta actual
    const currentAlert = state.sosAlertQueue[state.currentAlertIndex]
    if (currentAlert) {
      commit(types.SET_SOS_ALERT_DATA, currentAlert)
      commit(types.SET_SOS_ALERT_TIMESTAMP, currentAlert.timestamp)
      console.log('🔄 sosAlertData actualizado:', currentAlert)
    } else {
      console.warn('⚠️ No se pudo obtener la alerta actual del índice:', state.currentAlertIndex)
    }

    console.log('🚨 SOS Alert Added to Queue:', alertData)
    console.log('📊 Total alerts in queue:', state.sosAlertQueue.length)
  },

  deactivateSosAlert({ commit, state, dispatch }) {
    // Remover la alerta actual de la cola
    if (state.sosAlertQueue.length > 0) {
      commit(types.REMOVE_CURRENT_SOS_ALERT)

      // Si quedan alertas, mostrar la siguiente
      if (state.sosAlertQueue.length > 0) {
        // Ajustar índice si es necesario
        if (state.currentAlertIndex >= state.sosAlertQueue.length) {
          commit(types.SET_CURRENT_ALERT_INDEX, state.sosAlertQueue.length - 1)
        }

        // Actualizar la alerta visible
        const currentAlert = state.sosAlertQueue[state.currentAlertIndex]
        commit(types.SET_SOS_ALERT_DATA, currentAlert)
        commit(types.SET_SOS_ALERT_TIMESTAMP, currentAlert.timestamp)

        console.log('➡️ Showing next SOS alert:', currentAlert)
      } else {
        // No quedan alertas, desactivar completamente
        commit(types.SET_SOS_ALERT_ACTIVE, false)
        commit(types.SET_SOS_ALERT_DATA, null)
        commit(types.SET_SOS_ALERT_TIMESTAMP, null)
        commit(types.SET_CURRENT_ALERT_INDEX, 0)

        console.log('✅ All SOS Alerts cleared')
      }
    }
  },

  navigateToPreviousAlert({ commit, state }) {
    if (state.currentAlertIndex > 0) {
      const newIndex = state.currentAlertIndex - 1
      commit(types.SET_CURRENT_ALERT_INDEX, newIndex)

      const currentAlert = state.sosAlertQueue[newIndex]
      commit(types.SET_SOS_ALERT_DATA, currentAlert)
      commit(types.SET_SOS_ALERT_TIMESTAMP, currentAlert.timestamp)

      console.log('⬅️ Navigated to previous SOS alert:', currentAlert)
    }
  },

  navigateToNextAlert({ commit, state }) {
    if (state.currentAlertIndex < state.sosAlertQueue.length - 1) {
      const newIndex = state.currentAlertIndex + 1
      commit(types.SET_CURRENT_ALERT_INDEX, newIndex)

      const currentAlert = state.sosAlertQueue[newIndex]
      commit(types.SET_SOS_ALERT_DATA, currentAlert)
      commit(types.SET_SOS_ALERT_TIMESTAMP, currentAlert.timestamp)

      console.log('➡️ Navigated to next SOS alert:', currentAlert)
    }
  }
}

const mutations = {
  [types.SET_SOS_ALERT_ACTIVE](state, status) {
    state.sosAlertActive = status
  },

  [types.SET_SOS_ALERT_DATA](state, data) {
    state.sosAlertData = data
  },

  [types.SET_SOS_ALERT_TIMESTAMP](state, timestamp) {
    state.sosAlertTimestamp = timestamp
  },

  // Nuevas mutaciones para la cola
  [types.ADD_SOS_ALERT_TO_QUEUE](state, alertData) {
    state.sosAlertQueue.push(alertData)
  },

  [types.REMOVE_CURRENT_SOS_ALERT](state) {
    if (state.sosAlertQueue.length > 0) {
      state.sosAlertQueue.splice(state.currentAlertIndex, 1)
      // Ajustar índice si es necesario
      if (state.currentAlertIndex >= state.sosAlertQueue.length && state.sosAlertQueue.length > 0) {
        state.currentAlertIndex = state.sosAlertQueue.length - 1
      }
    }
  },

  [types.SET_CURRENT_ALERT_INDEX](state, index) {
    state.currentAlertIndex = index
  },

  [types.CLEAR_SOS_ALERT_QUEUE](state) {
    state.sosAlertQueue = []
    state.currentAlertIndex = 0
  },

  [types.TRIGGER_NEW_ALERT_SOUND](state) {
    state.newAlertTrigger += 1
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sosAlerts.js